import { render, staticRenderFns } from "./DocumentationLibrariesConfig.vue?vue&type=template&id=84b569fc&"
import script from "./DocumentationLibrariesConfig.vue?vue&type=script&lang=js&"
export * from "./DocumentationLibrariesConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports